import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col, Modal, notification } from "antd";
import { assignVehicleToBooking, assignVehicleToBookingCheck } from "../../../api/booking.service";
import { getDrivers } from "../../../api/user.service";
import { getVehicles } from "../../../api/vehicles.service";

const AssignVehicleToBookingModalForm = ({ fetchAllVehicles, vehicleData, onClose, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                selectedVehicleId: vehicleData.vehicleId || undefined, // Ensure it's properly set
            });
        } else {
            form.resetFields();
        }
    }, [vehicleData, form]);

    const handleConfirm = async (values) => {
        try {
            let data = await assignVehicleToBooking({
                vehicleId: values?.selectedVehicleId,
                bookingId: vehicleData?.id
            });

            notification.success({ message: "Vehicle Assigned Successfully" });
            fetchAllVehicles();
            setIsModalOpen(false);
            console.log("Confirmed");
        } catch (error) {
            notification.error({ message: "Vehicle Assigned Failed" });
            setIsModalOpen(false);
        }
    }

    const onFinish = async (values) => {
        try {
            let data = await assignVehicleToBookingCheck({
                vehicleId: values?.selectedVehicleId,
                bookingId: vehicleData?.id
            });
            let alreadyAssigned = data?.data?.alreadyAssigned
            if (alreadyAssigned) {
                Modal.confirm({
                    title: "Warning",
                    content: "This vehicle is already assigned to booking with reference no : " + data?.data?.referenceNo + ", selecting this may result in a timing clash, Are you sure you want to proceed?",
                    okText: "Confirm",
                    cancelText: "Cancel",
                    onOk() {
                        handleConfirm(values)
                    },
                    onCancel() {
                        console.log("Cancelled");
                    },
                });
            }
            else {
                Modal.confirm({
                    title: "Warning",
                    content: "Are you sure you want to proceed?",
                    okText: "Confirm",
                    cancelText: "Cancel",
                    onOk() {
                        handleConfirm(values)
                    },
                    onCancel() {
                        console.log("Cancelled");
                    },
                });
            }
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    const fetchVehicles = async () => {
        try {
            const response = await getVehicles();
            setOptions(
                response?.data?.map((elem) => ({
                    value: elem.id,
                    label: elem.registrationNo,
                })) || []
            );
        } catch (err) {
            notification.error({ message: "Failed to fetch vehicles" });
        }
    };

    useEffect(() => {
        fetchVehicles();
    }, []);

    return (
        <>
            <Modal
                footer={null}
                destroyOnClose
                title={`Assign Vehicle`}
                open={isModalOpen}
                onCancel={handleCancel}
            >
                <Form
                    disabled={isViewOnly}
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{ selectedVehicleId: "" }} // Ensure default values
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Select Vehicle"
                                name="selectedVehicleId"
                                rules={[{ required: true, message: "Please select vehicle" }]}
                            >
                                <Select
                                    className="vt-sel"
                                    placeholder="Select vehicle"
                                    options={options}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    {!isViewOnly && (
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    )}
                </Form>
            </Modal>
        </>
    );
};

export default AssignVehicleToBookingModalForm;
